import React from 'react';
import loader from '../pages/three/loader';

import effecturl from '../assets/texteffect.mp3';

const style = {
    width:'500px',
    height:'300px',
    position: 'absolute',   
    pointerEvents: 'none',
    opacity:0
};

const loading = {
    color:'white',
    position: 'absolute',
    fontSize: '16px',
    top:0,
    width:'100%',
    height:'100%',
    textAlign:'center',
    lineHeight:'300px',
    // backgroundColor:'rgba(0,0,0,0.5)',
    left:0
};

const qimen = {
    transform: 'translate(-45px, -264px)'
}
const dachangyu = {
    transform: 'translate(-455px, -264px)'
}
const sanyinjiao = {
    transform: 'translate(-45px, -264px)'
}
const taichong = {
    transform: 'translate(-455px, -264px)'
}
const tianshu = {
    transform: 'translate(-45px, -264px)'
}
const shenque = {
    transform: 'translate(-455px, -264px)'
}
const shangjuxu = {
    transform: 'translate(-455px, -264px)'
}

const canvasStyle = {
    width:'500px',
    height:'300px',
}

export default class ImageAnim extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading:false,
            visible:true
        }
    }
    componentDidMount() {
        // this.init();

    }

    init() {
        // let name = this.props.name;
        // // let pre = prefix + "qimen/渲染用_00";
        // let pre = prefix +name + "/渲染用_00";
        
        // loader.loaderImages(pre,'.png', 250, (images)=>{
        //     this.images = images;
        //     this.setState({loading:false});
        //     if( this.playing ) { 
        //         setTimeout(() => {
        //             this.play();
        //         }, 200);
        //     }
        // });
    }

    play(){

        let imgCfg = loader.getImageAnimCach(this.props.name)
        if( imgCfg.loading  ) {
            this.setState({loading:true});
            if( this.checkId ) return;
            this.checkId = setInterval(() => {
                this.play();
            }, 200);

            return;
        } 

        if( this.checkId ) {
            clearInterval( this.checkId )
            this.checkId = null;
        }


        let effect = this.refs.effect;
        if( !effect ) return;
        
        effect.currentTime = 0;
        effect.play();

        this.index = 0;
        this.playing = true;
        if( this.playId ) {
            return;
        }
        
        let canva = this.refs.canvas;
        let ctx =  canva.getContext('2d');
        canva.width = 500;
        canva.height = 300;
        this.index = 0;
        let total = 250;

        let images = imgCfg.imgs;
        this.playId = setInterval(() => {
            let index = this.index;
            this.index +=1;
            if( index >= 250) index = 0;
            let img = images[index];
            ctx.clearRect(0,0, 500, 300);
            ctx.drawImage(img, 0,0);
        }, 1000/24.0);
    }

    render() {
        // this.props.name
        let styles = { qimen,dachangyu ,sanyinjiao , taichong  ,tianshu  , shenque,shangjuxu };
        let loadingDom = <div style={loading}>loading...</div>;
        let canvasdom = <canvas ref="canvas" style={canvasStyle}></canvas>;

        let dom = this.state.loading? loadingDom : canvasdom;

        return (
            <div style={{...style , ...styles[this.props.name] }} ref="root">
                <audio src={effecturl} ref='effect'></audio>
               {
                   dom
               }
            </div>
        )
    }
}